import * as Types from '../../../generated.types'

import { PageInfoFragmentDoc } from '../../../fragments/PageInfoFragment_gen'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type InvoicesQueryVariables = Types.Exact<{
  orgId: Types.Scalars['Int']
  first?: Types.InputMaybe<Types.Scalars['Int']>
  after?: Types.InputMaybe<Types.Scalars['String']>
  last?: Types.InputMaybe<Types.Scalars['Int']>
  before?: Types.InputMaybe<Types.Scalars['String']>
  employerId?: Types.InputMaybe<Types.Scalars['Int']>
}>

export type InvoicesQuery = {
  __typename?: 'Query'
  organization?: {
    __typename?: 'Organization'
    id: number
    name?: string | null
    billing?: {
      __typename?: 'Billing'
      hasUnifiedBilling: boolean
      invoicesConnection: {
        __typename?: 'InvoiceConnection'
        pageInfo: {
          __typename?: 'PageInfo'
          startCursor?: string | null
          endCursor?: string | null
          hasNextPage: boolean
          hasPreviousPage: boolean
        }
        nodes?: Array<{
          __typename?: 'Invoice'
          id: number
          reference?: string | null
          ownerName?: string | null
          status: Types.InvoiceStatus
          isOverdue: boolean
          createdAt: string
          paidDate?: string | null
          startDate?: string | null
          billDate: string
          endDate?: string | null
          feeAmount: number
          paidAmount: number
          items: Array<{
            __typename?: 'InvoiceItem'
            id: number
            description?: string | null
            feeAmount: number
          }>
        } | null> | null
      }
    } | null
  } | null
}

export type InvoiceFragment = {
  __typename?: 'Invoice'
  id: number
  reference?: string | null
  ownerName?: string | null
  status: Types.InvoiceStatus
  isOverdue: boolean
  createdAt: string
  paidDate?: string | null
  startDate?: string | null
  billDate: string
  endDate?: string | null
  feeAmount: number
  paidAmount: number
  items: Array<{ __typename?: 'InvoiceItem'; id: number; description?: string | null; feeAmount: number }>
}

export const InvoiceFragmentDoc = `
    fragment Invoice on Invoice {
  id
  reference
  ownerName
  status
  isOverdue
  createdAt
  paidDate
  startDate
  billDate
  endDate
  feeAmount
  paidAmount
  items {
    id
    description
    feeAmount
  }
}
    `
export const InvoicesDocument = `
    query Invoices($orgId: Int!, $first: Int, $after: String, $last: Int, $before: String, $employerId: Int) {
  organization(id: $orgId) {
    id
    name
    billing {
      hasUnifiedBilling
      invoicesConnection(
        first: $first
        after: $after
        last: $last
        before: $before
        employerId: $employerId
      ) {
        pageInfo {
          ...PageInfo
        }
        nodes {
          ...Invoice
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${InvoiceFragmentDoc}`
export const useInvoicesQuery = <TData = InvoicesQuery, TError = Error>(
  variables: InvoicesQueryVariables,
  options?: UseQueryOptions<InvoicesQuery, TError, TData>
) =>
  useQuery<InvoicesQuery, TError, TData>(
    ['Invoices', variables],
    fetchGql<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, variables),
    options
  )

useInvoicesQuery.getKey = (variables: InvoicesQueryVariables) => ['Invoices', variables]
